import React from "react";
import { Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import imgNotFound from "../assets/images/not-found.png";
import "./NotFound.scss";

export default (props) =>
  <div className="NotFound">
    <img src={imgNotFound} alt="not found" />
    <Button variant="danger" size="sm"><Link to={props.isAuthenticated ? '/dashboard' : '/login'}>GO BACK TO THE APP</Link></Button>
  </div>;
